 import React, { useState } from 'react'
 import s from './Haqida.module.css'
 import { NavLink } from 'react-router-dom'
 import r from '../img/school/roms 1.png'
 import z from '../img/school/zal 1.png'
 import a from '../img/school/stol.png' 
 import k from '../img/school/karidor.png'
 import p from '../img/school/parta.png'
 import t from '../img/school/tree.png'
 import o from '../img/school/stol1.png'
 import q from '../img/school/qaridor.png'
 import h from '../img/school/home.png'
 import m from '../img/school/math 1.png'
 import { Image } from 'antd';
 const Haqida = () => {

  const [visible, setVisible] = useState(false); 

   return ( 
     <div>
        <div className={s.menu}>
          <h1>Информация о 2-школа</h1>
          <div className={s.btn2}>
              <NavLink to={'/haqida'} className={s.link}> <button>О Школе</button></NavLink>
              <NavLink to={'/ramzlar'} className={s.link}><button>Cимволы</button></NavLink>
            </div>
        </div>
        <div className={s.menu2}>
            <div className={s.img}>
              <div></div>
              <div>
              <p>2-Школa</p>
              <h1>Информация о школе</h1>
              <h2>Здесь вы можете посмотреть фотографии и полную информацию о школе</h2>
              </div>
            </div>
        </div>
          <div className={s.menu3}> 
              <Image
                preview={{ visible: false }}
                width={"65%"} 
                src={t}
                onClick={() => setVisible(true)}
              />
              <div style={{ display: 'none' }}>
                <Image.PreviewGroup preview={{ visible, onVisibleChange: vis => setVisible(vis) }}>
                  <Image src={r} />
                  <Image src={z} />
                  <Image src={a} />
                  <Image src={k} />
                  <Image src={p} />
                  <Image src={t} />
                  <Image src={o} />
                  <Image src={q} />
                  <Image src={h} />
                  <Image src={m} />
              </Image.PreviewGroup>
              </div>
          </div>
          <div className={s.menu4}>
            <div className={s.bla}>
                <div className={s.te}>
                  <p>Learn your pace</p>
                  <h1>Flexible Studt at Your Own Pace</h1>
                </div>
                <div></div>
            </div>
            <div className={s.num3}>
                    <div className={s.div1}>
                      <div className={s.status}>
                        <h1>1,093</h1>
                        <p>Finished Sessions</p>
                      </div>
                      <div className={s.status}>
                        <h1>3,355</h1>
                        <p>Enrolled Learners</p>
                      </div>
                    </div>
                    <div className={s.div1}>
                      <div className={s.status}>
                        <h1>40</h1>
                        <p>Online Instructors</p>
                      </div>
                      <div className={s.status}>
                        <h1>90%</h1> 
                        <p>Satisfaction Rate</p>
                      </div>
                    </div>
              </div>
              <div className={s.bla2}>
                <div className={s.video}></div>
                <div></div>
              </div>
          </div>
         
     </div>
   ) 
 }
 
 export default Haqida